"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var dispatch_custom_event_1 = require("@opten/events/dispatch-custom-event");
var get_transition_end_event_name_1 = require("../get-transition-end-event-name");
var transitionEndEventName = get_transition_end_event_name_1.default();
function addTransitionEndListener(element, callback, fallbackDuration, remove) {
    if (fallbackDuration === void 0) { fallbackDuration = 0; }
    if (remove === void 0) { remove = true; }
    var called = false;
    var listener = function (event) {
        called = true;
        if (remove) {
            element.removeEventListener(transitionEndEventName, listener);
        }
        callback();
    };
    if (transitionEndEventName === false) {
        setTimeout(function () {
            callback();
        }, fallbackDuration);
    }
    else {
        element.addEventListener(transitionEndEventName, listener);
        // https://github.com/twbs/bootstrap/blob/v4.0.0/js/src/util.js#L49
        if (fallbackDuration) {
            setTimeout(function () {
                if (!called) {
                    dispatch_custom_event_1.default(element, transitionEndEventName);
                }
            }, fallbackDuration);
        }
    }
}
exports.default = addTransitionEndListener;
